import { useEffect } from 'react';

const PageMetadata = ({ metadata }) => {
  useEffect(() => {
    const previousTitle = document.title;
    const descriptionMeta = document.querySelector('meta[name="description"]');
    const previousDescription = descriptionMeta?.getAttribute('content');

    document.title = metadata.title;
    descriptionMeta?.setAttribute('content', metadata.description);

    return () => {
      document.title = previousTitle;
      if (previousDescription) {
        descriptionMeta?.setAttribute('content', previousDescription);
      }
    };
  }, [metadata.description, metadata.title]);

  return null;
};

export default PageMetadata;
